import type { MatchHit } from "@/features/search/components/Results/models/matchHit";
import { useTitles } from "@/hooks/graphql/useTitles";
import { TitleIcon } from "@/features/shell/components/shared/TitleIcon";
import React from "react";
import { ResultsInIndex } from "./ResultsInIndex/ResultsInIndex";
import { Row } from "./Row/Row";

import { Highlight } from "./Highlight/Highlight";
import { NextHighlight } from "./Highlight/NextHighlight";
import { useNormalisedHits } from "@/features/search/components/Results/hooks/useNormalisedHits";

export const MatchResults = () => {
  const { items, results } = useNormalisedHits<MatchHit>();
  const titles = useTitles();

  return (
    <ResultsInIndex
      indexName={`Matches`}
      total={results?.nbHits || 0}
      pages={results?.nbPages || 0}
      perPage={results?.hitsPerPage || 0}
    >
      {(items || []).map((item) => {
        const urlPrefix =
          item.sportCategory === "conventional" ? "/sports" : "";

        const tournamentHighlight = item.normalisedHighlights?.tournament?.[0];
        const eventHighlight = item.normalisedHighlights?.event?.[0];

        return (
          <Row
            key={item.objectID}
            eventId={item.objectID}
            icon={<TitleIcon title={titles[item.sport?.toLowerCase()]} />}
            subTitle={
              <Highlight
                text={item.tournament}
                matchedWords={tournamentHighlight?.matchedWords || []}
                html={tournamentHighlight?.value || ""}
              />
            }
            title={
              <Highlight
                text={item.event}
                matchedWords={eventHighlight?.matchedWords || []}
                html={eventHighlight?.value || ""}
              />
            }
            to={`${urlPrefix}/betting/${item.type}/${item.objectID}`}
            startTime={item.type === "match" ? item.startTime : undefined}
            highlight={
              <NextHighlight
                highlights={item.normalisedHighlights}
                ignore={["tournament.0", "event.0"]}
              />
            }
          />
        );
      })}
    </ResultsInIndex>
  );
};
